import { Typography } from 'antd'
import styled from 'styled-components'

const { Text } = Typography

const TableCell = styled.div`
  display: table-cell;
  border: 1px solid rgba(0, 0, 0, 0.12);
  vertical-align: middle;
`

export const SelectResponseTableCell = styled(TableCell)`
  min-width: ${({ theme }) => theme.minWidth};
  width: ${({ theme }) => theme.width};
  background-color: ${({ theme }) => theme.backgroundColor};
`

export const SelectAnswerWrapper = styled.div`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  margin-left: 12px;
`

export const MultipleChoiceSetText = styled(Text)`
  font-weight: bold;
`
